import { AnalyticAction } from '@application/analytic/analytic.service';
import { HeaderStateService } from '@application/header_state.service';
import { tokens } from '@cellula/react-theme-patient';
import { HeaderNavController } from '@controllers/header_nav.controller';
import { useService } from '@visiba/instantiation';
import { usePresentation } from '@visiba/presentation';
import styled from 'styled-components';
import { LinkHome } from './_header_nav_link_home.component';
import { LinkMyCases } from './_header_nav_link_my_cases.component';
import { LinkReceptionPicker } from './_header_nav_link_reception_picker.component';

interface Props {
	trackEvent: (action: AnalyticAction) => void;
	__TEMP__navigate?: (url: string) => void;
}

const elements = {
	wrapper: styled.div`
		display: none;

		${tokens.breakpointQuery.medium} {
			display: grid;
			grid-template-columns: repeat(3, 1fr);
			width: 100%;
			height: 100%;
		}
	`,
};

export function Nav({ __TEMP__navigate, trackEvent }: Props): JSX.Element {
	const headerNavController = useService(HeaderNavController);
	const { showLinkHome, showLinkReceptionPicker, showLinkMyCases } = usePresentation(headerNavController.presentation);
	const headerService = useService(HeaderStateService);
	const visibility = headerService.visibility.value;

	function handleClick(action: AnalyticAction): void {
		trackEvent(action);
	}

	return (
		<elements.wrapper>
			{showLinkHome ? <LinkHome trackEvent={handleClick} __TEMP__navigate={__TEMP__navigate} /> : null}
			{showLinkReceptionPicker && visibility.showSearchReception ? (
				<LinkReceptionPicker trackEvent={handleClick} __TEMP__navigate={__TEMP__navigate} />
			) : null}
			{showLinkMyCases && visibility.showMyVisits ? (
				<LinkMyCases trackEvent={handleClick} __TEMP__navigate={__TEMP__navigate} />
			) : null}
		</elements.wrapper>
	);
}
